import { useEffect, useState } from "react";
import { Menu, X, MessageCircle, CalendarCheck } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV } from "../data/content";
import { useSite } from "../context/SiteContext";

export const Nav = () => {
  const site = useSite();
  const { pathname } = useLocation();
  const prefix = pathname === "/" ? "" : "/";
  const WHATSAPP_URL = site.whatsappUrl;
  const BOOKING_URL = site.booking_url;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-500 ${scrolled || open ? "bg-sand/85 shadow-[0_1px_0_rgba(23,53,43,0.08)] backdrop-blur-xl" : "bg-transparent"}`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-6 xl:flex">
          {NAV.map((n) => (
            <a key={n.href} href={prefix + n.href} data-testid={`nav-${n.href.slice(1)}`} className="link-underline whitespace-nowrap text-sm font-medium text-ink/80 hover:text-ink">
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <span className="hidden sm:inline-flex">
            <a href={BOOKING_URL} target="_blank" rel="noreferrer" data-testid="nav-check-rates-btn" className="btn-ghost whitespace-nowrap">
              <CalendarCheck className="h-4 w-4" /> Check Rates
            </a>
          </span>
          <span className="hidden 2xl:inline-flex">
            <a href={`${prefix}#contact`} data-testid="nav-partner-btn" className="btn-primary">Partner With Us</a>
          </span>
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="nav-whatsapp-btn" aria-label="WhatsApp" className="grid h-11 w-11 place-items-center rounded-full border border-ink/15 text-ink transition-colors hover:bg-ink hover:text-sand">
            <MessageCircle className="h-4 w-4" />
          </a>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="grid h-11 w-11 place-items-center rounded-full border border-ink/15 xl:hidden" aria-label="Menu">
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="border-t border-ink/10 px-5 pb-6 xl:hidden">
          {NAV.map((n) => (
            <a key={n.href} href={prefix + n.href} onClick={() => setOpen(false)} className="block border-b border-ink/10 py-4 font-display text-2xl text-ink">
              {n.label}
            </a>
          ))}
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" onClick={() => setOpen(false)} data-testid="mobile-check-rates-btn" className="btn-ghost mt-5 w-full justify-center">
            <CalendarCheck className="h-4 w-4" /> Check Rates
          </a>
          <a href={`${prefix}#contact`} onClick={() => setOpen(false)} className="btn-primary mt-3 w-full justify-center">Partner With Us</a>
        </div>
      )}
    </header>
  );
};
